//getting store and combine reducers from redux and redux toolkit
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
/////////////////////////////////////////////////////////////////

//getting persist Reducer from redux-persist for persisting data
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import storage from 'redux-persist/lib/storage/session';

////////////////////////////////////////////////////////////////

//getting Reducers from
// Below Common
import userDetailSlice from "./Reducers/Logindetails";
// import SelecTypeSlice from "./Reducers/TabChange";
// import AlertSlice from "./Reducers/Common/Alerts";
import ADNSlice from "./Reducers/Common/AssDatesByName";
import ANameSlice from "./Reducers/Common/AssessmentName";
import DateDetailSlice from "./Reducers/Common/AssessmentDate";
import SelecYearSlice from "../Redux/Reducers/Common/Year";
import PaginationSlice from "../Redux/Reducers/Common/Pagination";
import SelectLanguageSlice from "../Redux/Reducers/Common/Language";
import LanguageOptionSlice from "./Reducers/Common/Languageoptions";
import InstSlice from "./Reducers/Common/InstValue";
// Below Student
import AssessmentDetailSlice from "./Reducers/Student/AssessmentDetails";

// Below Teacher - principle
import SWResultSlice from "./Reducers/Teachers/Results/StudentWiseResults";
// Below Principle
import PrincipalTeacherDashboard from "./Reducers/Principle/PPerformanceT";
// Below HQ Admin
import AllSubjectData from "./Reducers/HQAdmin/PerformanceOverallSubjects";
import StateDetailsData from "./Reducers/HQAdmin/StatePerformanceDetails";
import DistrictDetailsData from "./Reducers/HQAdmin/DistrictPerformanceDetails";
// Below QB Admin
import ScenarioSlice from "./Reducers/QBAdmin/Editscenario";
import QuestionSlice from "./Reducers/QBAdmin/EditQuestions";
import FQSlice from "./Reducers/QBAdmin/FilterQDeatails";

//  Below NCL Admin

import TestSlice from "./Reducers/NCLadmin/AddEditTest";
import SchoolSlice from "./Reducers/NCLadmin/AddEditSchool";

// Language
import LanguageQuestionSlice from "./Reducers/QBAdmin/LanguageEditQuestions";
////////////////////////////////////////////////////////////
const reducers = combineReducers({
  // Common
  // TesTypedata: SelecTypeSlice,
  userDetailsData: userDetailSlice,
  ADNOptionsData: ADNSlice,
  ANameData: ANameSlice,
  DateDetailsData: DateDetailSlice,
  SelecYearData: SelecYearSlice,
  PaginationNo: PaginationSlice,
  SelectLanguageData: SelectLanguageSlice,
  LanguageOptionsData: LanguageOptionSlice,
  SelecTInstData:InstSlice,
  // Student
  AssessmentDetailsdata: AssessmentDetailSlice,

  // Teacher / Principle
  SWResultsData: SWResultSlice,

  // Priciple
  PrincipalTeacherDashboarData: PrincipalTeacherDashboard,
  // Hq Admin
  SubjectsData: AllSubjectData,
  StateDetails: StateDetailsData,
  DistrictDetails: DistrictDetailsData,
  // QB Admin
  ScenarioDeatils: ScenarioSlice,
  QuestionDeatils: QuestionSlice,
  FQDetails: FQSlice,
  // NCL Admin
  EditTest: TestSlice,
  EditSchool: SchoolSlice,
  // Language QB Admin
  LanguageQuestionDeatils: LanguageQuestionSlice,
});
const persistConfig = {
  key: "root",
  version: 1,
  storage,
};
const persistedReducer = persistReducer(persistConfig, reducers);
export const store = configureStore({ reducer: persistedReducer });
